import { Directive, TemplateRef, inject } from '@angular/core';

export interface InmCarouselItemContext {
  $implicit: unknown;
  index: number;
  animate: boolean;
}

@Directive({
  selector: '[inmCarouselItem]',
  standalone: true,
})
export class InmCarouselItem {
  readonly templateRef = inject<TemplateRef<InmCarouselItemContext>>(TemplateRef);
}
